module.exports = __webpack_public_path__ + "img/mainarticle2.d41c2d36.png";